<script>
    export let emailAddress;
    export let trackBetaSignup;
</script>

<svelte:head>
	<script src="https://sibforms.com/forms/end-form/build/main.js" ></script>
	<link rel="stylesheet" href="https://sibforms.com/forms/end-form/build/sib-styles.css">
</svelte:head>

<div class="sib-form" style="text-align:center;">
    <div id="sib-form-container" class="sib-form-container">
    <div id="error-message" class="sib-form-message-panel" style="font-size:16px; text-align:left; font-family:&quot;Helvetica&quot;, sans-serif; color:#661d1d; background-color:#ffeded; border-radius:3px; border-color:#ff4949;max-width:540px;">
        <div class="sib-form-message-panel__text sib-form-message-panel__text--center">
        <svg viewBox="0 0 512 512" class="sib-icon sib-notification__icon">
            <path d="M256 40c118.621 0 216 96.075 216 216 0 119.291-96.61 216-216 216-119.244 0-216-96.562-216-216 0-119.203 96.602-216 216-216m0-32C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm-11.49 120h22.979c6.823 0 12.274 5.682 11.99 12.5l-7 168c-.268 6.428-5.556 11.5-11.99 11.5h-8.979c-6.433 0-11.722-5.073-11.99-11.5l-7-168c-.283-6.818 5.167-12.5 11.99-12.5zM256 340c-15.464 0-28 12.536-28 28s12.536 28 28 28 28-12.536 28-28-12.536-28-28-28z" />
        </svg>
        <span class="sib-form-message-panel__inner-text">
                            Your subscription could not be saved. Please try again.
                        </span>
        </div>
    </div>
    <div></div>
    <div id="success-message" class="sib-form-message-panel" style="font-size:16px; text-align:left; font-family:&quot;Helvetica&quot;, sans-serif; color:#085229; background-color:#e7faf0; border-radius:3px; border-color:#13ce66;max-width:540px;">
        <div class="sib-form-message-panel__text sib-form-message-panel__text--center">
            <svg viewBox="0 0 512 512" class="sib-icon sib-notification__icon">
                <path d="M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 464c-118.664 0-216-96.055-216-216 0-118.663 96.055-216 216-216 118.664 0 216 96.055 216 216 0 118.663-96.055 216-216 216zm141.63-274.961L217.15 376.071c-4.705 4.667-12.303 4.637-16.97-.068l-85.878-86.572c-4.667-4.705-4.637-12.303.068-16.97l8.52-8.451c4.705-4.667 12.303-4.637 16.97.068l68.976 69.533 163.441-162.13c4.705-4.667 12.303-4.637 16.97.068l8.451 8.52c4.668 4.705 4.637 12.303-.068 16.97z" />
            </svg>
            <span class="sib-form-message-panel__inner-text">
                                Your subscription has been successful.
                            </span>
        </div>
    </div>
    <div></div>
    <div id="sib-container" class="sib-container--large sib-container--vertical" style="background:transparent;">
        <form id="sib-form" method="POST" style="display:flex;max-width:500px;margin:auto;margin-top:20px;" action="https://384ad18b.sibforms.com/serve/MUIEAMUwSOQt8eJGlnikTuUsgXk7Vht_mAc4VzIaACza99C1uu5m9rQUA6IPSt6C8XBvUbElehnurG500khX9HHyaMlQwmRNVEqWczTvE1OvqEb9Z7XbiDt-clKwF7IeGfIQpHWipYo5ubR8mBT1GfwENHvRJGi-DYeKiQyvUdOMzGWQZELyqWSjVYKhiP_6dPgE2piSswOVZ5FB" data-type="subscription">
            <div style="flex:60;">
                <div class="sib-input sib-form-block">
                <div class="form__entry entry_block">
                    <div class="form__label-row ">
    
                    <div class="entry__field">
                        <input bind:value={emailAddress} class="input" type="text" id="EMAIL" name="EMAIL" autocomplete="off" placeholder="Email" data-required="true" required />
                    </div>
                    </div>
    
                    <label class="entry__error entry__error--primary" style="font-size:16px; text-align:left; font-family:&quot;Helvetica&quot;, sans-serif; color:#661d1d; background-color:#ffeded; border-radius:3px; border-color:#ff4949;">
                    </label>
                </div>
                </div>
            </div>
            <div style="flex:40;">
                <div class="sib-form-block" style="text-align: left">
                <button 
                    on:click="{trackBetaSignup(emailAddress)}"
                    class="sib-form-block__button sib-form-block__button-with-loader" style="font-size:16px; text-align:left; font-weight:700; font-family:&quot;Helvetica&quot;, sans-serif; color:#FFFFFF; background-color:rgb(171, 70, 79); border-radius:3px; border-width:0px;margin-bottom:0;width:100%;text-align:center;" form="sib-form" type="submit">
                    <svg class="icon clickable__icon progress-indicator__icon sib-hide-loader-icon" viewBox="0 0 512 512">
                    <path d="M460.116 373.846l-20.823-12.022c-5.541-3.199-7.54-10.159-4.663-15.874 30.137-59.886 28.343-131.652-5.386-189.946-33.641-58.394-94.896-95.833-161.827-99.676C261.028 55.961 256 50.751 256 44.352V20.309c0-6.904 5.808-12.337 12.703-11.982 83.556 4.306 160.163 50.864 202.11 123.677 42.063 72.696 44.079 162.316 6.031 236.832-3.14 6.148-10.75 8.461-16.728 5.01z" />
                    </svg>
                    Get Early Access
                </button>
                </div>
            </div>
    
            <input type="text" name="email_address_check" value="" class="input--hidden">
            <input type="hidden" name="locale" value="en">
        </form>
    </div>
    </div>
</div>

<style>

#sib-container input:-ms-input-placeholder {
      text-align: left;
      font-family: "Helvetica", sans-serif;
      color: #c0ccda;
    }
  
    #sib-container input::placeholder {
      text-align: left;
      font-family: "Helvetica", sans-serif;
      color: #c0ccda;
    }
  
    #sib-container textarea::placeholder {
      text-align: left;
      font-family: "Helvetica", sans-serif;
      color: #c0ccda;
    }
    .sib-form{padding:0}
    #sib-container{padding:0}
    .sib-form-block{padding:0}
    .sib-form-message-panel{margin:0 0 1.25rem 0;width:100%;padding:0.4375rem;border:1px solid;display:none}
    .sib-form .entry__field{margin:0;}
    .input--hidden{display: none !important}
    .sib-form .clickable__icon:not(.sib-icon_standalone) {
        margin-right: calc(.7002rem - 1px);
    }
    .sib-form .progress-indicator__icon {
        -webkit-animation: indicator-spin 1.3s cubic-bezier(0.46, 0.35, 0.39, 0.85) infinite;
        animation: indicator-spin 1.3s cubic-bezier(0.46, 0.35, 0.39, 0.85) infinite;
    }
    .sib-form .clickable__icon {
        height: 1.5rem;
        vertical-align: bottom;
        width: 1.5rem;
    }
    .sib-hide-loader-icon {
        display: none;
    }
    .sib-form *, .sib-form ::after, .sib-form ::before {
        box-sizing: border-box;
    }

    @media only screen and (max-width: 767px) {
        #sib-form {
            flex-direction: column;
        }
    }
</style>